import { comparisonColor, comparisonPositive } from '../../helpers/Custom';
import { Dashboard } from '../../models/ApiModels';
import ColumnChart from './ColumnChart';
import PieChart from './PieChart';

interface Props {
  dashboardData: Dashboard;
  compare: boolean;
}

function DashboardDataSystems(props: Props) {
  const overviewToMap = [
    {
      label: 'Delivered YTD',
      className: 'prose-heading3',
      data: props.dashboardData.systems.ytdAmountOfSystems,
      suffix: '',
    },
    {
      label: 'Warranty form',
      className: 'prose-heading3 text-success-100',
      data: props.dashboardData.systems.extendedWarrantyPercentage,
      suffix: '%',
    },
    {
      label: 'Active warranty',
      className: 'prose-heading3',
      data: props.dashboardData.systems.activeWarranty,
      suffix: '',
    },
  ];

  return (
    <>
      <div className='prose-heading4 mb-5 mt-10'>Systems</div>
      <div className='md:flex md:flex-wrap gap-4'>
        <div className='bg-gray-3 pt-4 px-4 mb-4 md:mb-0 flex-1 flex flex-col'>
          <div className='text-center mt-4'>System statuses</div>
          <div className='flex-1'>
            {props.dashboardData && (
              <PieChart
                compare={props.compare}
                series={[
                  props.dashboardData.systems.statusCreated,
                  props.dashboardData.systems.statusConfigured,
                  props.dashboardData.systems.statusInstalling,
                  props.dashboardData.systems.statusActive,
                  props.dashboardData.systems.statusPendingLicense,
                ]}
                colors={['#646868', '#E6E8E8', '#9BE6EE', '#BFE5A7', '#FEB1B1']}
                labels={['Created', 'Configured', 'Installing', 'Active', 'Pending License']}
                showMarkers={false}
              />
            )}
          </div>
          <div className='w-full max-w-3xl mx-auto flex justify-center gap-8 md:gap-16 mt-auto pb-8 px-4'>
            {props.dashboardData &&
              overviewToMap.map((item) => (
                <div key={item.label} className='text-center flex-1 min-w-0'>
                  <div>{item.label}</div>
                  <h3 className={item.className}>
                    {item.data.count}
                    {item.suffix}
                  </h3>
                  {props.compare && (
                    <span className={`prose-heading4 ${comparisonColor(item.data.diff)}`}>
                      {comparisonPositive(item.data.diff) + item.data.diff}
                    </span>
                  )}
                </div>
              ))}
          </div>
        </div>
        <div className='flex flex-wrap w-full justify-center bg-gray-3 pt-4 px-4 mb-4 md:mb-0 flex-1'>
          <div>
            <div className='text-center mt-4'>Systems connected within timespan</div>
            {props.compare ? (
              <div className='prose-paragraphBase text-center py-8 px-4'>
                This part of the dashboard does not support comparing yet.
              </div>
            ) : (
              props.dashboardData && (
                <ColumnChart
                  colorSetting='connected'
                  series={props.dashboardData.systems.timeSinceConnected}
                  labels={props.dashboardData.systems.timeSinceConnected.map((item) => item.key)}
                  compare={props.compare}
                  xAxisTitle='Latest connection date'
                  yAxisTitle='Total systems'
                />
              )
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default DashboardDataSystems;
